import { __extends } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-menu.css';

var getClassNameList = classNames.bind(styles);
var UitkMenuIconTrigger = /** @class */ (function (_super) {
    __extends(UitkMenuIconTrigger, _super);
    function UitkMenuIconTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMenuIconTrigger.prototype.render = function () {
        var _a = this.props, analytics = _a.analytics, className = _a.className, icon = _a.icon, iconId = _a.iconId, iconSize = _a.iconSize, iconTitle = _a.iconTitle, onClick = _a.onClick;
        var cssClassNames = getClassNameList('uitk-menu-icon-trigger', className);
        return (React.createElement("button", { type: "button", "aria-expanded": this.props['aria-expanded'], className: cssClassNames, onClick: onClick, onClickCapture: analyticsTracker.bind(this, analytics) },
            React.createElement(UitkIcon, { name: icon, title: iconTitle, id: iconId, size: iconSize })));
    };
    UitkMenuIconTrigger.displayName = 'UitkMenuIconTrigger';
    UitkMenuIconTrigger.baseClassName = 'uitk-menu-icon-trigger';
    return UitkMenuIconTrigger;
}(React.Component));

export { UitkMenuIconTrigger };
